//src/constants/index.js
import { t } from "i18next";
import { about_page, about_section, herobg1 } from "../assets/Images";
import { herobg2 } from "../assets/Images";
import { herobg3 } from "../assets/Images";
import { herobg4 } from "../assets/Images";
import {
  IoBookSharp,
  TbLogs,
  FaVideo,
  clints,
  victory,
  Hands,
  Experiance,
  IoLogoWhatsapp,
  SiFacebook,
  FaYoutube,
  FaHome,
  FaInfoCircle,
  FaHandsHelping,
  FaUsers,
  FaBook,
  FaEnvelope,
  IoIosCreate,
  TbCategoryFilled,
  MdCreateNewFolder,
  BiSolidCategory,
  IoPieChartSharp,
  FaTelegram,
  FaXTwitter,
  FaBalanceScale,
  FaTasks
} from "../components/utils/icons";

const HeroImages = [
  {
    id: 0,
    img: herobg1,
    titleAr: "التميز القانوني",
    titleEn: "Legal Excellence ",
    subTitleAr: "خبرة تمتد لعقود لضمان نجاحك القانوني",
    subTitleEn: "Decades of experience ensuring your legal success.",
  },
  {
    id: 1,
    img: herobg2,
    titleAr: "دعم متكامل",
    titleEn: "Comprehensive Support",
    subTitleAr: "نقدم لك الدعم القانوني الشامل في كل خطوة ",
    subTitleEn: "We provide you with full legal support at every step.",
  },
  {
    id: 2,
    img: herobg3,
    titleAr: "إدارة قضايا",
    titleEn: "Case Management",
    subTitleAr: "نقدم حلولاً فعالة لإدارة قضاياك بكفاءة عالية",
    subTitleEn:
      "We provide effective solutions to handle your cases with high efficiency.",
  },
  {
    id: 3,
    img: herobg4,
    titleAr: "الدفاع الموثوق",
    titleEn: "Reliable Advocacy",
    subTitleAr: "حماية حقوقك بنزاهة وخبرة",
    subTitleEn: "Protecting your rights with integrity and expertise.",
  },
];
const FotterText = {
  textEn:
    "Al-Noman Law Firm for Legal Advocacy and Consultations - We provide comprehensive legal solutions with the highest level of professionalism, ensuring your rights and enhancing your success through a team of specialized lawyers with extensive experience in various legal fields.",
  textAr:
    "مؤسسة النعمان للمحاماة والاستشارات القانونية - نقدم حلولاً قانونية متكاملة باحترافية عالية، نضمن لك حقوقك ونعزز نجاحك من خلال فريق من المحامين المتخصصين ذوي الخبرة الواسعة في مختلف المجالات القانونية.",
};


export const aboutUsData = {
  images: {
    page: about_page,
    section: about_section,
  },

  // Adjust this route to match your React Router configuration
  links: {
    contact: "/contact",
  },

  /* ============================================
     ARABIC CONTENT
  ============================================ */

  ar: {
    home: "الرئيسية",
    about: "من نحن",

    /* HERO */
    hero: {
      eyebrow: "مكتب النعمان للمحاماة والاستشارات القانونية",
      title: "المعرفة القانونية",
      highlight: "في خدمة العدالة",

      description:
        "نرافق موكلينا بفهم قانوني دقيق، ورؤية واضحة للإجراءات، واهتمام مهني يحفظ الحقوق ويراعي خصوصية كل قضية.",

      discover: "تعرف على المكتب",
      expertise: "مجالات الخبرة",

      traits: [
        "الالتزام المهني",
        "وضوح المشورة",
        "العناية بالتفاصيل",
      ],

      sideTitle: "القانون مسؤولية قبل أن يكون مهنة",

      sideDescription:
        "نؤمن بأن الثقة تبدأ بفهم القضية، والوضوح في المشورة، والعمل المنظم في كل مرحلة.",

      sideNote: "المعرفة • المسؤولية • العدالة",
    },

    /* INTRODUCTION */
    introduction: {
      eyebrow: "تعرف على المكتب",

      title: "خبرة قانونية تتكامل مع العمل بروح الفريق",

      paragraphs: [
        "مكتب النعمان للمحاماة والاستشارات القانونية مكتب يمني يضم فريقًا من المحامين، ويعمل على تقديم التمثيل القانوني والمشورة للأفراد والجهات في مجموعة من القضايا والمسائل القانونية.",

        "ينطلق عملنا من دراسة الوقائع والمستندات بعناية، وشرح الخيارات المتاحة بوضوح، ثم اختيار المسار الإجرائي الملائم وفق طبيعة كل قضية والتشريعات اليمنية ذات الصلة.",

        "ونولي عناية خاصة بإعداد المذكرات القانونية ومتابعة إجراءات التقاضي والطعون، مع المحافظة على السرية المهنية والتواصل المنظم مع الموكلين.",
      ],

      imageAlt: "مكتب قانوني يضم ميزان العدالة والملفات القانونية",

      imageCaption:
        "فهمٌ دقيق للقضية، وعملٌ قانوني قائم على المسؤولية.",

      footnote:
        "ننظر إلى كل قضية باعتبارها مسؤولية تستحق الدراسة والاهتمام.",
    },

    /* EXPERTISE */
    expertise: {
      eyebrow: "مجالات عملنا",

      title: "خبرات قانونية في مجالات متعددة",

      description:
        "نتعامل مع مجموعة من المسائل القانونية التي تتطلب الدراسة والتحليل والإعداد المهني، مع مراعاة خصوصية كل قضية والأنظمة القانونية ذات الصلة.",

      cardLabel: "مجال قانوني",

      items: [
        {
          title: "التقاضي والمرافعات",
          description:
            "التمثيل القانوني أمام المحاكم، وإعداد الدعاوى والمذكرات والدفوع، ومتابعة إجراءات التقاضي والطعون.",
        },
        {
          title: "الاستشارات القانونية",
          description:
            "دراسة المسائل القانونية وتوضيح الحقوق والالتزامات والخيارات المتاحة للأفراد والجهات.",
        },
        {
          title: "القضايا التجارية والشركات",
          description:
            "المشورة القانونية المتعلقة بالعقود والمعاملات التجارية والشركات والمنازعات الناشئة عنها.",
        },
        {
          title: "قضايا الأحوال الشخصية",
          description:
            "التعامل مع المسائل القانونية المتعلقة بالزواج والطلاق والحضانة والنفقة والمواريث.",
        },
        {
          title: "القضايا المدنية والعقارية",
          description:
            "دراسة المنازعات المدنية والعقارية وما يتعلق بالملكية والحيازة والالتزامات التعاقدية.",
        },
        {
          title: "القضايا الجنائية",
          description:
            "التمثيل والدفاع القانوني في القضايا الجزائية، ودراسة الوقائع والأدلة والإجراءات.",
        },
      ],
    },

    /* PROCESS */
    process: {
      eyebrow: "كيف نعمل؟",

      title: "منهجية واضحة في التعامل مع القضايا",

      description:
        "نعتمد خطوات منظمة تساعد على فهم المسألة القانونية، وتقييم الخيارات المتاحة، وتحديد الإجراءات المناسبة لكل حالة.",

      steps: [
        {
          title: "فهم القضية",
          description:
            "الاستماع إلى تفاصيل المسألة ومراجعة الوقائع والمستندات الأساسية.",
        },
        {
          title: "الدراسة والتحليل",
          description:
            "تحليل الوقائع والنصوص القانونية ذات الصلة وتحديد المسائل المؤثرة.",
        },
        {
          title: "تحديد المسار القانوني",
          description:
            "توضيح الخيارات والإجراءات الممكنة واختيار المسار المناسب.",
        },
        {
          title: "الإعداد والمتابعة",
          description:
            "إعداد المستندات القانونية اللازمة ومتابعة الإجراءات والمستجدات.",
        },
      ],
    },

    /* VALUES */
    values: {
      eyebrow: "مبادئنا المهنية",

      title: "قيم نلتزم بها في كل مرحلة",

      description:
        "العمل القانوني مسؤولية تتطلب المعرفة والوضوح والاهتمام بثقة الموكل.",

      items: [
        {
          title: "الأمانة والسرية",
          description:
            "التعامل مع معلومات الموكلين ومستنداتهم بمسؤولية واحترام للخصوصية المهنية.",
        },
        {
          title: "الدقة والتحليل",
          description:
            "دراسة الوقائع والنصوص والمستندات قبل بناء الرأي القانوني أو اتخاذ الإجراء.",
        },
        {
          title: "الوضوح والمتابعة",
          description:
            "توضيح الخطوات القانونية والتواصل بشأن مستجدات القضايا بقدر ما تسمح به إجراءاتها.",
        },
      ],
    },

    /* PURPOSE */
    purpose: {
      eyebrow: "ما نؤمن به",

      title: "رؤية مهنية ورسالة واضحة",

      description:
        "نسعى إلى تقديم عمل قانوني يرتكز على الفهم والمسؤولية والاحترام العميق للحقوق والقانون.",
    },

    /* MISSION */
    mission: {
      label: "رسالتنا",

      title: "مساندة قانونية تبدأ بالفهم",

      description:
        "تقديم خدمات قانونية جادة تُراعي ظروف كل موكل، وتجمع بين التحليل المتأني والإعداد المهني والمتابعة المسؤولة.",
    },

    /* VISION */
    vision: {
      label: "رؤيتنا",

      title: "ثقة تُبنى بالممارسة",

      description:
        "العمل على أن يكون المكتب وجهة مهنية موثوقة للمشورة والتمثيل القانوني، وأن يسهم في تعزيز الثقافة القانونية واحترام سيادة القانون.",
    },

    /* FAQ */
    faq: {
      eyebrow: "الأسئلة الشائعة",

      title: "إجابات عن أكثر الاستفسارات شيوعًا",

      description:
        "معلومات تمهيدية تساعدك على فهم آلية التواصل مع المكتب والاستعداد لمناقشة مسألتك القانونية.",

      note:
        "لكل قضية ظروفها الخاصة، وقد تختلف الإجراءات بحسب الوقائع والمستندات والتشريعات ذات الصلة.",

      items: [
        {
          question: "كيف يمكنني طلب استشارة قانونية؟",
          answer:
            "يمكنك التواصل مع المكتب لعرض موضوع الاستشارة وتحديد طبيعة المسألة والمستندات اللازمة لمراجعتها، ثم الاتفاق على الخطوة المناسبة.",
        },
        {
          question: "ما المستندات التي ينبغي تجهيزها قبل الاستشارة؟",
          answer:
            "يعتمد ذلك على نوع المسألة القانونية. وبصورة عامة، يُفضّل تجهيز العقود والمراسلات والأحكام والمستندات ذات الصلة، مع ترتيب الوقائع والتواريخ المهمة.",
        },
        {
          question: "هل يتم التعامل مع معلومات القضايا بسرية؟",
          answer:
            "السرية المهنية من المبادئ الأساسية في العمل القانوني. وتُعامل المعلومات والمستندات المتعلقة بالموكلين وفق الالتزامات المهنية والقانونية المعمول بها.",
        },
        {
          question: "هل يمكن الطعن في الأحكام القضائية؟",
          answer:
            "تتوقف إمكانية الطعن والطريق المتاح له على نوع الحكم وطبيعته والإجراءات والمواعيد القانونية ذات الصلة. ولذلك يلزم مراجعة الحكم وملف القضية لتقييم الخيارات.",
        },
        {
          question: "هل يقدم المكتب خدمات للأفراد والشركات؟",
          answer:
            "يتناول عمل المكتب مسائل قانونية تخص الأفراد والجهات والشركات، وتُحدد طبيعة الخدمة المناسبة بعد مراجعة الموضوع ومتطلباته.",
        },
      ],
    },

    /* CLOSING */
    closing: {
      eyebrow: "نهجنا في العمل",

      title: "لكل قضية تفاصيلها، ولكل حق ما يستحقه من عناية.",

      description:
        "نؤمن بأن القرار القانوني الأفضل يبدأ باستيعاب الوقائع ومعرفة الخيارات والإجراءات المتاحة.",

      contactButton: "تواصل مع المكتب",
      backButton: "تعرف علينا أكثر",
    },
  },

  /* ============================================
     ENGLISH CONTENT
  ============================================ */

  en: {
    home: "Home",
    about: "About Us",

    /* HERO */
    hero: {
      eyebrow: "Al Noman Law Office & Legal Consultations",

      title: "Legal Knowledge",
      highlight: "In the Service of Justice",

      description:
        "We support our clients through thoughtful legal analysis, a clear understanding of procedures, and professional attention to each case's circumstances.",

      discover: "Discover Our Office",
      expertise: "Areas of Practice",

      traits: [
        "Professional Commitment",
        "Clear Legal Advice",
        "Attention to Detail",
      ],

      sideTitle: "Law Is a Responsibility Before It Is a Profession",

      sideDescription:
        "We believe trust begins with understanding the case, providing clear advice, and following a structured approach.",

      sideNote: "Knowledge • Responsibility • Justice",
    },

    /* INTRODUCTION */
    introduction: {
      eyebrow: "Get to Know Our Office",

      title: "Legal Experience, Strengthened by Teamwork",

      paragraphs: [
        "Al Noman Law Office is a Yemeni legal practice with a team of lawyers serving individuals and organizations through legal representation and advice across a range of matters.",

        "Our approach begins with a careful review of facts and documents, a clear explanation of available options, and a choice of appropriate procedures in light of each case and relevant Yemeni laws.",

        "We pay particular attention to legal briefs, litigation procedures, and appeals, while maintaining professional confidentiality and organized communication with clients.",
      ],

      imageAlt:
        "A professional law office with scales of justice and legal case files",

      imageCaption:
        "A careful understanding of every case, guided by responsibility.",

      footnote:
        "We regard every case as a responsibility deserving careful study and attention.",
    },

    /* EXPERTISE */
    expertise: {
      eyebrow: "Our Practice Areas",

      title: "Legal Experience Across Multiple Fields",

      description:
        "We address a range of legal matters requiring careful research, professional preparation, and consideration of the circumstances of each case.",

      cardLabel: "Practice Area",

      items: [
        {
          title: "Litigation & Court Representation",
          description:
            "Legal representation before courts, preparation of claims, briefs, defenses, and follow-up on litigation and appeals.",
        },
        {
          title: "Legal Consultations",
          description:
            "Reviewing legal matters and explaining rights, obligations, and available options for individuals and organizations.",
        },
        {
          title: "Commercial & Corporate Law",
          description:
            "Legal advice on commercial contracts, business transactions, companies, and related disputes.",
        },
        {
          title: "Family & Personal Status Law",
          description:
            "Legal matters involving marriage, divorce, child custody, maintenance, and inheritance.",
        },
        {
          title: "Civil & Real Estate Matters",
          description:
            "Civil and property disputes involving ownership, possession, and contractual obligations.",
        },
        {
          title: "Criminal Law",
          description:
            "Legal representation and defense in criminal matters, including review of evidence and procedures.",
        },
      ],
    },

    /* PROCESS */
    process: {
      eyebrow: "How We Work",

      title: "A Structured Approach to Legal Matters",

      description:
        "Our process focuses on understanding the legal issue, assessing available options, and identifying appropriate steps for each case.",

      steps: [
        {
          title: "Understanding the Case",
          description:
            "Listening to the client's concerns and reviewing the essential facts and documents.",
        },
        {
          title: "Legal Research & Analysis",
          description:
            "Examining relevant facts and legal provisions and identifying the key issues.",
        },
        {
          title: "Defining the Legal Approach",
          description:
            "Explaining available options and selecting the appropriate procedural path.",
        },
        {
          title: "Preparation & Follow-Up",
          description:
            "Preparing relevant legal documents and following the case's procedures and developments.",
        },
      ],
    },

    /* VALUES */
    values: {
      eyebrow: "Our Professional Principles",

      title: "Values Guiding Every Stage",

      description:
        "Legal practice carries responsibilities that require knowledge, clarity, and respect for every client's trust.",

      items: [
        {
          title: "Integrity & Confidentiality",
          description:
            "Handling client information and documents responsibly, with respect for professional privacy.",
        },
        {
          title: "Precision & Analysis",
          description:
            "Reviewing facts, applicable legal provisions, and evidence before recommending action.",
        },
        {
          title: "Clarity & Follow-Through",
          description:
            "Explaining legal steps and communicating case developments as procedures permit.",
        },
      ],
    },

    /* PURPOSE */
    purpose: {
      eyebrow: "What We Believe In",

      title: "A Clear Mission and Professional Vision",

      description:
        "We strive to provide legal work grounded in understanding, responsibility, and respect for rights and the law.",
    },

    /* MISSION */
    mission: {
      label: "Our Mission",

      title: "Legal Support Begins with Understanding",

      description:
        "To provide dedicated legal services tailored to each client's circumstances, combining careful analysis, professional preparation, and responsible follow-through.",
    },

    /* VISION */
    vision: {
      label: "Our Vision",

      title: "Trust Built Through Practice",

      description:
        "To be a dependable destination for legal advice and representation while contributing to legal awareness and respect for the rule of law.",
    },

    /* FAQ */
    faq: {
      eyebrow: "Frequently Asked Questions",

      title: "Answers to Common Legal Service Questions",

      description:
        "Introductory information to help you understand how to approach our office and prepare for a discussion of your legal matter.",

      note:
        "Every legal matter has its own circumstances, and procedures may differ according to the facts, documents, and applicable laws.",

      items: [
        {
          question: "How can I request a legal consultation?",
          answer:
            "You may contact the office to explain your legal concern, identify relevant documents, and discuss the appropriate next step.",
        },
        {
          question: "What documents should I prepare?",
          answer:
            "Requirements vary by matter. Generally, it helps to gather contracts, correspondence, judgments, and other relevant records, together with a clear timeline.",
        },
        {
          question: "Will my information be handled confidentially?",
          answer:
            "Professional confidentiality is a fundamental principle of legal practice. Client information and documents are handled in accordance with applicable professional and legal obligations.",
        },
        {
          question: "Can court judgments be appealed?",
          answer:
            "The possibility and method of appeal depend on the type of judgment, applicable procedures, and legal deadlines. A review of the decision and case documents is necessary.",
        },
        {
          question: "Does the office assist individuals and businesses?",
          answer:
            "The office handles legal matters concerning individuals, organizations, and businesses. The appropriate service depends on the circumstances and requirements of each matter.",
        },
      ],
    },

    /* CLOSING */
    closing: {
      eyebrow: "Our Approach",

      title:
        "Every Case Has Its Details; Every Right Deserves Attention.",

      description:
        "We believe sound legal decisions begin with understanding the facts, available options, and relevant procedures.",

      contactButton: "Contact Our Office",
      backButton: "Learn More About Us",
    },
  },
};

const navItems = [
  {
    id: 1,
    titleEn: "Home",
    titleAr: "الرئيسية",
    link: "/",
    icon: <FaHome />,
  },
  {
    id: 2,
    titleEn: "About",
    titleAr: "من نحن",
    link: "/AboutUs",
    icon: <FaInfoCircle />,
  },
  {
    id: 3,
    titleEn: "Our Services",
    titleAr: "الممارسات",
    link: "/AllServiceses",
    icon: <FaHandsHelping />,
  },
  {
  id: 4,
  titleAr: "مقالات",
  titleEn: "Blogs",
  link: "/BlogsCategory",
  icon: <TbLogs />,
  },
  {
    id: 5,
    titleAr: "الفيديوهات",
    titleEn: "videos",
    link: "/VideoCategoryPage",
    icon: <FaVideo />,
  },
  {
    id: 6,
    titleAr: "الكتب",
    titleEn: "books",
    link: "/AllBooks",
    icon: <IoBookSharp />,
  }
];
const countUpData = [
  {
    id: 1,
    titleEn: "Closed Cases",
    titleAr: "قضايا مغلقة",
    count: 201560,
    icon: victory,
  },
  {
    id: 2,
    titleEn: "Clients",
    titleAr: "عملاء",
    count: 300000,
    icon: clints,
  },
  {
    id: 3,
    titleEn: "Years Experience",
    titleAr: "سنوات الخبرة",
    count: 40,
    icon: Experiance,
  },
  {
    id: 4,
    titleEn: "Lawyers",
    titleAr: "محامين",
    count: 15,
    icon: Hands,
  },
];
const socialMedia = [
  {
    id: 0,
    titleAr: "يوتيوب",
    titleEn: "YouTube",
    icon: <FaYoutube />,
    link: "https://youtube.com/@anomanlawyer?si=L8WdoXRQLu1vokM_",
  },
  {
    id: 1,
    titleAr: "فيسبوك",
    titleEn: "Facebook",
    icon: <SiFacebook />,
    link: "https://www.facebook.com/share/1CA7xziWAY/",
  },
  {
    id: 2,
    titleAr: "واتس أب",
    titleEn: "WhatsApp",
    icon: <IoLogoWhatsapp />,
    link: "https://wa.me/777332887",
  },
  {
    id: 3,
    titleAr: "تيليجرام",
    titleEn: "Telegram",
    icon: <FaTelegram/>,
    link: "https://t.me/anomanlawyer1",
  },
  {
    id: 3,
    titleAr: "تويتر",
    titleEn: "twitter",
    icon: <FaXTwitter />,
    link: "https://x.com/WoN3D57sP5Ks3wU?t=5RztNjtNsW_62-kJamzqGg&s=09",
  },
];

const localeTextGrid = {
  columnMenuSortAsc: t('Sort Ascending'), // ترتيب تصاعدي
  columnMenuSortDesc: t('Sort Descending'), // ترتيب تنازلي
  columnMenuUnsort: t('Unsort'), // إلغاء الترتيب
  columnMenuHideColumn: t('Hide Column'), // إخفاء العمود
  columnMenuManageColumns: t('Manage Columns'), // إدارة الأعمدة
  columnsPanelTextFieldLabel: t('Find column'), // البحث عن عمود
  columnsPanelTextFieldPlaceholder: t('Column title'), // عنوان العمود
  columnsPanelShowAllButton: t('Show all'), // عرض الكل
  columnsPanelHideAllButton: t('Hide all'), // إخفاء الكل
  columnsManagementReset: t('Reset'), // إعادة تعيين
  columnsManagementSearchTitle: t('Search'), // ترجمة كلمة "Search"

};

const UserLinks=[
  
  {
    title:"Dashboard",
links:[
  {
    name: "All Cases",
    icon: <FaBalanceScale />,
    linkSide: "userAllCases",
  },
  {
    name: "All Pleadings",
    icon: <FaTasks />,
    linkSide: "userAllPleadings",
  },
]
  },
]
const AdminLinks = [

  {
    title:"Dashboard",
links:[
  {
    name: "Dashboard",
    icon: <IoPieChartSharp />,
    linkSide: "admin",
  }
]
  },
  {
    title: "Blogs",

    links: [
      {
        name: "All Blogs",
        icon: <TbLogs />,
        linkSide: "DAllBlogsPage",
      },
    
   
      {
        name: "Create Blogs",
        icon: <IoIosCreate />,
        linkSide: "CreateBlogPage",
      },
      {
        name: "Blogs Categorys",
        icon: <TbCategoryFilled />,
        linkSide: "DAllCategoryPge",
      },
      {
        name: "Create Blogs Categorys",
        icon: <MdCreateNewFolder />,
        linkSide: "CreateCategoryPage",
      },
    ],
    
  },

  {
    title: "Books",
    links: [
      {
        name: "All Books",
        icon: <IoBookSharp />,
        linkSide: "DAllBooksPage",
      },
  
   
        {
          name: "Create Book",
          icon: <IoIosCreate />,
          linkSide: "CreateBookPage",
        },
    ]
  },
  {
    title: "Videos",
    links: [
      {
        name: "All Videos",
        icon: <FaVideo />,
        linkSide: "DAllVideosPage",
      },
      {
        name: "Create Video",
        icon: <IoIosCreate />,
        linkSide: "CreateVideoPage",
      },
      {
        name: "Vedios Categorys",
        icon: <TbCategoryFilled />,
        linkSide: "DAllVideoCategoryPage",
      },
      {
        name: "Create Vedios Categorys",
        icon: <MdCreateNewFolder />,
        linkSide: "CreateVideoCategoryPage",
      },
    ],
  },
  {
    title: "Practices",
    links: [
      {
        name: "All Practices",
        icon: <FaHandsHelping />,
        linkSide: "DAllServicesPage",
      },
      {
        name: "Create Practice",
        icon: <IoIosCreate />,
        linkSide: "CreateServicePage",
      },
    ],
  },
  {
    title: "Reviews",
    links: [
      {
        name: "All Reviews",
        icon: <FaHandsHelping />,
        linkSide: "DAllReviewsPage",
      },
      {
        name: "Create Review",
        icon: <IoIosCreate />,
        linkSide: "CreateReviewPage",
      },
    ],
  },
  {
    title: "Cases",
    links: [
      {
        name: "All Cases",
        icon: <FaBalanceScale />,
        linkSide: "DallCase",
      },
      {
        name: "Create Case",
        icon: <IoIosCreate />,
        linkSide: "CreateCase",
      },
    ],
  },
  {
    title: "Pleadings",
    links: [
      {
        name: "All Pleadings",
        icon: <FaTasks />,
        linkSide: "DallPleading",
      },
      {
        name: "Create Pleading",
        icon: <IoIosCreate />,
        linkSide: "CreatePleading",
      },
    ],
  },
];

const DeletButtonStyle={
  color: '#fff',
  background: 'linear-gradient(to right, #dc2626, #b91c1c, #dc2626)',
  boxShadow: '0 4px 6px -1px rgba(220, 38, 38, 0.5), 0 2px 4px -2px rgba(220, 38, 38, 0.5)',
  border: 'none',

  borderRadius:"5px",
  cursor: 'pointer',
  transition: 'all 0.3s ease',
}

const DeleteonMouseEnter= (e) => {
  e.currentTarget.style.background = 'linear-gradient(to bottom right, #dc2626, #b91c1c)';
}
const DeleteonMouseLeave=(e) => {
  e.currentTarget.style.background = 'linear-gradient(to right, #dc2626, #b91c1c, #dc2626)';
}
const DeleteonFocus=(e) => {
  e.currentTarget.style.outline = 'none';
  e.currentTarget.style.boxShadow = '0 0 0 4px rgba(185, 28, 28, 0.5)';
}
const DeleteonBlur=(e) => {
  e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(220, 38, 38, 0.5), 0 2px 4px -2px rgba(220, 38, 38, 0.5)';
}
const EditButtonStyle =
{
  color: '#fff',
  backgroundImage: 'linear-gradient(to right, #eab308, #ca8a04, #eab308)',
  boxShadow: '0 4px 6px -1px rgba(234, 179, 8, 0.5), 0 2px 4px -2px rgba(234, 179, 8, 0.5)',
  border: 'none',

 borderRadius:"5px",
  cursor: 'pointer',
  transition: 'all 0.3s ease',
}
const EditonMouseEnter=(e) => {
  e.currentTarget.style.background = 'linear-gradient(to bottom right, #eab308, #ca8a04)';
}
const EditonMouseLeave=(e) => {
  e.currentTarget.style.background = 'linear-gradient(to right, #eab308, #ca8a04, #eab308)';
}
const EditonFocus=(e) => {
  e.currentTarget.style.outline = 'none';
  e.currentTarget.style.boxShadow = '0 0 0 4px rgba(202, 138, 4, 0.5)';
}
const EditonBlur=(e) => {
  e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(234, 179, 8, 0.5), 0 2px 4px -2px rgba(234, 179, 8, 0.5)';
}

const ViewButtonStyle = {
  color: '#fff',
  background: 'linear-gradient(to right, #16a34a, #15803d, #16a34a)',
  boxShadow: '0 4px 6px -1px rgba(22, 163, 74, 0.5), 0 2px 4px -2px rgba(22, 163, 74, 0.5)',
  border: 'none',
  borderRadius: "5px",
  cursor: 'pointer',
  transition: 'all 0.3s ease',
}

const ViewonMouseEnter = (e) => {
  e.currentTarget.style.background = 'linear-gradient(to bottom right, #16a34a, #15803d)';
}

const ViewonMouseLeave = (e) => {
  e.currentTarget.style.background = 'linear-gradient(to right, #16a34a, #15803d, #16a34a)';
}

const ViewonFocus = (e) => {
  e.currentTarget.style.outline = 'none';
  e.currentTarget.style.boxShadow = '0 0 0 4px rgba(21, 128, 61, 0.5)';
}

const ViewonBlur = (e) => {
  e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(22, 163, 74, 0.5), 0 2px 4px -2px rgba(22, 163, 74, 0.5)';
}

export {
  HeroImages,
  navItems,
  countUpData,
  FotterText,
  socialMedia,

  UserLinks,
  AdminLinks,
  localeTextGrid,
  DeletButtonStyle,
  DeleteonMouseEnter,
  DeleteonMouseLeave,
  DeleteonFocus,
  DeleteonBlur,
  EditButtonStyle,
  EditonMouseEnter,
  EditonMouseLeave,
  EditonFocus,
  EditonBlur,
  ViewButtonStyle,
  ViewonMouseEnter,
  ViewonMouseLeave,
  ViewonFocus,
  ViewonBlur,

  
};
